angular.module('services.users', ['http.users']).factory('userService', function (httpUsers) {
  class UserService {
    static getOrgUsers() {
      return httpUsers.getOrgUsers();
    }
  }
  return UserService;
});
